import { isEmbeddedInIframe } from '@/shared/embed/is-embedded';
import { isAllowedCockpitEmbedParentOrigin } from '@/shared/embed/cockpit-embed-origins';

const MESSAGE_SOURCE = 'condo-cockpit';
const MESSAGE_TYPE = 'ram-navigate';

export type CockpitEmbedNavigate = (to: string) => void | Promise<unknown>;

/**
 * When RAM runs inside a Cockpit iframe, react to programmatic navigation from the parent
 * so the SPA is not reloaded on every sidebar switch (parent avoids changing iframe.src).
 *
 * @param navigate — app-layer navigation (e.g. `router.navigate`); injected to keep `shared/` free of `app/` imports.
 */
export function initCockpitEmbedNavigation(navigate: CockpitEmbedNavigate): void {
    if (!isEmbeddedInIframe()) {
        return;
    }

    window.addEventListener('message', (event: MessageEvent) => {
        if (!isAllowedCockpitEmbedParentOrigin(event.origin)) {
            return;
        }
        const data = event.data as { source?: string; type?: string; to?: string };
        if (data?.source !== MESSAGE_SOURCE || data?.type !== MESSAGE_TYPE) {
            return;
        }
        if (typeof data.to !== 'string' || !data.to.startsWith('/')) {
            return;
        }
        void navigate(data.to);
    });
}
